export const DEFAULT_COTRADER_LANGUAGE = "English";

export const COTRADER_LANGUAGE_LIST = [
  "English",
  "Chinese",
  "Japanese",
  "Korean",
  "Hindi",
  "Indonesian",
  "Vietnamese",
  "Thai",
  "Spanish",
  "Arabic",
  "French",
  "Portuguese",
  "Russian",
  "German",
  "Italian",
  "Turkish",
  "Malay",
  "Persian",
  "Filipino",
  "Dutch",
  "Polish",
  "Swahili",
  "Ukrainian",
  "Greek",
  "Hebrew",
];

export const normalizeCoTraderLanguage = (language) =>
  COTRADER_LANGUAGE_LIST.includes(language)
    ? language
    : DEFAULT_COTRADER_LANGUAGE;

export const getStoredCoTraderLanguage = () =>
  normalizeCoTraderLanguage(localStorage.getItem("user_language"));
